import React, { lazy, Suspense } from "react";

const LazyEventInformation = lazy(() => import("./EventInformation"));

const EventInformation = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => (
  <Suspense fallback={null}>
    <LazyEventInformation {...props} />
  </Suspense>
);

export default EventInformation;
